module.exports = __webpack_public_path__ + "img/broadband-result-low.82105e03.svg";